import { ReactNode } from 'react'
import styled from 'styled-components'

import WarningCard from '../../components/cards/WarningCard'
import YogaDetailedIcon from '../../components/icons/YogaDetailed'

const IllustrationWrapper = styled.div`
  margin-bottom: 24px;

  svg {
    margin: 0 auto;
    width: 90px;
    height: 90px;
  }
`

const Message = styled.p`
  font-size: ${({ theme }) => theme['-ds-font-size-lg']['font-size'].value};
  font-weight: 400;
  line-height: 1.5;
  margin: 0 auto 24px auto;
  max-width: 500px;
`

const ApologiesWrapper = styled.div`
  margin-top: 40px;

  & > * {
    margin: 0 auto;
  }
`

const Inner = styled.div`
  color: ${({ theme }) => theme['-ds-neutral-700'].value};
  text-align: center;
`

const Outer = styled.div`
  padding: 30px;
  margin: 0 auto;
`

type EmptyProps = {
  message?: ReactNode
  apologiesMessage?: {
    title: ReactNode
    body: ReactNode
  }
  actions?: ReactNode
}

const Empty = ({ message, apologiesMessage, actions }: EmptyProps) => {
  return (
    <Outer>
      <Inner>
        <IllustrationWrapper>
          <YogaDetailedIcon />
        </IllustrationWrapper>

        <Message>
          {message || (
            <>Uh-oh! We can&apos;t find anything that matches your search.</>
          )}
        </Message>

        {actions}

        {apologiesMessage && (
          <ApologiesWrapper>
            <WarningCard
              title={apologiesMessage.title}
              message={apologiesMessage.body}
            />
          </ApologiesWrapper>
        )}
      </Inner>
    </Outer>
  )
}

export default Empty
